import React, { Suspense, useEffect, useState } from "react";
import LoadingIndicator from "../components/LoadingIndicator";
import ContentBox from "../components/contents/ContentBox";
import PageWrapper from "../components/PageWrapper";
import SortByTag from "../components/SortByTag";
import { getData } from "../FatchApi/FatchApi";

const OrderedProductPreview = React.lazy(() =>
  import("../components/products/OrderedProductPreview")
);

const ManageOrderPage = () => {
  const [allOrders, setAllOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const getAllOrders = async () => {
    const res = await getData("api/orders/get-all-order");

    const sortedProducts = (res?.AllOrders || []).sort((a, b) => {
      return new Date(b.orderDate) - new Date(a.orderDate);
    });

    setAllOrders(sortedProducts);
  };
  useEffect(() => {
    getAllOrders();
  }, []);


  const filteredOrders = allOrders?.filter((order) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();

    const orderIdMatch = order?._id?.toLowerCase().includes(term);

    const customerNameMatch =
      order?.customerName?.toLowerCase().includes(term) ||
      order?.deliveryAddress?.address?.name?.toLowerCase().includes(term);

    const productIdMatch = order?.items?.some((item) => {
      const prodId = item?._id?._id || item?._id;
      return prodId?.toString().toLowerCase().includes(term);
    });

    return orderIdMatch || customerNameMatch || productIdMatch;
  });

  return (
    <PageWrapper>
      <ContentBox
        name="Manage Orders"
        showSearch
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
      >
        <>
          <div className="border-b border-b-glitch-box">
            {/* <SortByTag
              tags={["Pending (129)", "Accepted (13)", "Shipped (6)"]}
            /> */}
          </div>

          {/* Products list */}
          <div className="mt-5"></div>
          <Suspense fallback={<LoadingIndicator />}>
            <ul className="px-5 bg-transparent">
              {filteredOrders?.map((Order, i) => (
                <li
                  className="block mt-4 pb-4 border-b border-b-glitch-box last:border-none"
                  key={i}
                >
                  <OrderedProductPreview
                    orderId={Order?._id}
                    order={Order}
                    onDelete={(id) => setAllOrders((prev) => prev.filter((o) => o._id !== id))}
                  />
                </li>
              ))}
            </ul>
          </Suspense>
        </>
      </ContentBox>
    </PageWrapper>
  );
};

export default ManageOrderPage;
